// EditStudent Component for update student data 

// Import Modules 
import React, { useState, useEffect } from "react";
import { useParams, useNavigate,useOutletContext } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import PatientArtawawruttaForm from "../Forms/PatientArtawawruttaForm";
import CONFIG from '../../config';

import { usePatient } from "../../context/PatientContext";
import { useAuth } from "../../context/AuthProvider";

// EditStudent Component 
const EditPatientArtawawrutta = () => {
  const { markSectionComplete } = useOutletContext() ;  
  const navigate = useNavigate();
  const { verifyTokenAndRedirect } = useAuth();
  const { patientData, setPatientData, selectedCase, selectedVisit, doctorInfo } = usePatient();
  const {patientId, caseId, visitId} = useParams();
  const location = useLocation();
  // const token = localStorage.getItem("authToken");
  useEffect(() => {

    verifyTokenAndRedirect();

  }, []);


  //onSubmit handler 
  const onSubmitHandler = (updatedPatientArtawawrutta) => {


    // const updatedData = {
    //   ...patientData,
    //   patientArtawawrutta: [{ ...updatedPatientArtawawrutta }] // Overwrite patientInfo while keeping other data unchanged
    // };

    // const updatedData = {
    //   ...patientData, 
    //   patientArtawawrutta: patientData.patientArtawawrutta.map(info => ({
    //       ...info, // Keep existing patientInfo fields
    //       ...updatedPatientArtawawrutta // Merge updated fields
    //   }))
    // };

  //   const updatedData = {
  //     ...patientData,
  //     patientArtawawrutta: patientData.patientArtawawrutta.length > 0 
  //         ? patientData.patientArtawawrutta.map(info => ({
  //             ...info, // Keep existing patientInfo fields
  //             ...updatedPatientArtawawrutta // Merge updated fields
  //         }))
  //         : [updatedPatientArtawawrutta] // If empty, create a new array with updatedPatientArtawawrutta
  // };

  const updatedData = {
    ...patientData,
    patientArtawawrutta: patientData?.patientArtawawrutta?.length > 0 
        ? patientData.patientArtawawrutta.map(info => ({
            ...info, // Keep existing patientInfo fields
            ...updatedPatientArtawawrutta, // Merge updated fields
            PATIENT_ID: patientData.PATIENT_ID, 
            CASE_ID: selectedCase || caseId, // Add CASE_ID if missing
            VISIT_ID: selectedVisit || visitId,  // Add VISIT_ID if missing
            DOCTOR_ID: doctorInfo.MANDALI_ID,
            CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields
    
        }))
        : [{
            ...updatedPatientArtawawrutta,
            PATIENT_ID: patientData.PATIENT_ID, 
            CASE_ID: selectedCase || caseId,  // Default CASE_ID if not provided
           VISIT_ID: selectedVisit || visitId, // Default VISIT_ID if not provided
           DOCTOR_ID: doctorInfo.MANDALI_ID,
           CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields
   
        }]
  };
    

    setPatientData(updatedData);
    markSectionComplete("artawawrutta");
    if (location.pathname.startsWith("/addpatient")) {
      navigate("/addpatient/diagnosis");
    } else if (location.pathname.startsWith("/visits")) {
      navigate(`/visits/${patientId}/${caseId}/${visitId}/diagnosis`);
    } else {
      console.warn("Unknown route, no redirection");
    }
  };

  // Return student form 
  return (

    <div>
      {console.log('inside rendering: ', patientData)}
      {patientData && (
        <PatientArtawawruttaForm
          initialValues={patientData}
          onSubmit={onSubmitHandler}
          enableReinitialize={true}
        >
          Update Patient
        </PatientArtawawruttaForm>
      )}
    </div>
  );

};

export default EditPatientArtawawrutta;

